export default "__VITE_ASSET__CP$ovNy2__"